import update from 'immutability-helper'

// ------------------------------------
// Constants
// ------------------------------------
export const SET_DUMO_DESC = 'SET_DUMO_DESC'
export const SET_DUMO_START_TIME = 'SET_DUMO_START_TIME'
export const SET_WINDOW_MODAL = 'SET_WINDOW_MODAL'

// ------------------------------------
// Actions
// ------------------------------------
export const setDumoDesc = (desc = '') => ({
  type: SET_DUMO_DESC,
  value: desc,
})

export const setCountdownValue = (value = 0) => ({
  type: SET_DUMO_START_TIME,
  value,
})

export const enterModalMode = (value = true) => ({
  type: SET_WINDOW_MODAL,
  value,
})

// ------------------------------------
// Specialized Action Creator
// ------------------------------------
// export const storeUserInput = ({ dispatch }) => {
//   return value => dispatch(setDumoDesc(value))
// }

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = null
export default function interactionsReducer(state = initialState, action = {}) {
  const reducerFunctions = {
    [SET_DUMO_DESC]: () => {
      return update(state, { dumoFieldValue: { $set: action.value } })
    },
    [SET_DUMO_START_TIME]: () => {
      return update(state, { countdownValue: { $set: action.value } })
    },
    [SET_WINDOW_MODAL]: () => {
      return update(state, { modalMode: { $set: action.value } })
    },
  }

  const fn = reducerFunctions[action.type] || (() => state)

  return fn()
}



// WEBPACK FOOTER //
// ./src/store/interactions.js